const fileSizeValidator = (max, message = "") => function(value, state) {
  if (value && value > max) {
    return message || `File is too large`;
  }

  return null;
};

export default fileSizeValidator;
